module.exports = __webpack_public_path__ + "img/asian-noodles-2.b0b12be1.jpg";